export enum UserRole {
	ADMIN = "global_admin",
	ORG_ADMIN = "org_admin",
	RESPONDENT = "respondent",
}
